let isGoogleMapsLoading = false;

export const loadGoogleMaps = () => {

  return new Promise((resolve) => {

    if (window.google && window.google.maps) {



      return resolve();
    }

    if (isGoogleMapsLoading) {


      const interval = setInterval(() => {

        if (window.google && window.google.maps) {

          clearInterval(interval);

          resolve();
        }

      }, 100);

      return;
    }

    isGoogleMapsLoading = true;

    const script =
      document.createElement("script");

    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places,drawing,geometry`;

    script.async = true;
    script.defer = true;

    script.onload = () => {



   
      resolve();
    };

    document.head.appendChild(script);
  });
};